/**
 * Formerly restyled Shopify Inbox as a second floating pill.
 * With the Ted “Besoin d’aide ?” panel, hide the native Chat launcher instead.
 */
(function () {
  var hideCss =
    'button.chat-toggle,#dummy-chat-button,button[aria-label*="Chat" i],button[aria-label*="chat" i]{' +
    'opacity:0!important;pointer-events:none!important;' +
    'width:1px!important;height:1px!important;overflow:hidden!important;' +
    'position:fixed!important;right:-9999px!important;bottom:0!important;z-index:-1!important;' +
    '}';

  function inject(el) {
    if (!el || el._tedHideChatLauncher) return;
    var target = el.shadowRoot || (el.contentDocument && el.contentDocument.head);
    if (!target) return;
    var style = document.createElement('style');
    style.textContent = hideCss;
    target.appendChild(style);
    el._tedHideChatLauncher = true;
  }

  function run() {
    // While chat is open from our support panel, do not collapse the host
    if (document.documentElement.hasAttribute('data-ted-chat-open')) return;

    document.querySelectorAll('shopify-chat, inbox-online-store-chat, #shopify-chat').forEach(function (host) {
      inject(host);
      if (host.shadowRoot) inject(host);
      host.style && host.style.setProperty('--shopify-chat-activator-offset', '-9999px');
      var inner = host.querySelector && (host.querySelector('inbox-online-store-chat') || host.querySelector('iframe'));
      if (inner) inject(inner);
    });
    var iframe = document.querySelector('#dummy-chat-button-iframe');
    if (iframe) inject(iframe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(run, 500);
  setTimeout(run, 2000);
})();
